import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Select from "react-select";

// css
import styles from "./AssignDriverPop.module.scss";


const AssignDriverPop = ({
  assignDriverModel,
  setAssignDriverModel,
  assignModelData,
}) => {
  const storeOption = [
    { value: "Sandbox", label: "Sandbox" },
    { value: "UPI", label: "UPI" },
    { value: "Cash", label: "Cash" },
  ];
  const orderOption = [
    { value: "Sandbox", label: "Sandbox" },
    { value: "UPI", label: "UPI" },
    { value: "Cash", label: "Cash" },
  ];
  const handleAssignDriver = () => setAssignDriverModel((p) => !p);

  return (
    <>
      <Modal
        show={assignDriverModel}
        className={`${styles.AssignDriverPop} transparentModal`}
        onHide={handleAssignDriver}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <h5 className="m-0">Assign Driver</h5>
        </Modal.Header>
        <Modal.Body className="">
          <div className="cardBox shadow-sm rounded p-3">
            <Form>
              <Row>
                <Col lg="12" className="my-2">
                  <ul className="list-unstyled ps-0 mb-0">
                    <li className="d-flex py-1 align-items-start gap-10">
                      <p className="m-0 fw-sbold">Driver Name:</p>
                      <span className="text-muted">
                        {assignModelData?.name || "-"}
                      </span>
                    </li>
                    <li className="d-flex py-1 align-items-start gap-10">
                      <p className="m-0 fw-sbold">Driver Mobile Number:</p>
                      <span className="text-muted">
                        {" "}
                        {assignModelData?.mobileNumber || "-"}
                      </span>
                    </li>
                    <li className="d-flex py-1 align-items-start gap-10">
                      <p className="m-0 fw-sbold">Driver Email:</p>
                      <span className="text-muted">
                        {" "}
                        {assignModelData?.email || "-"}
                      </span>
                    </li>
                  </ul>
                </Col>
                <Col lg="12" className="my-2">
                  <Select options={storeOption} />
                </Col>
                <Col lg="12" className="my-2">
                  <Select options={orderOption} />
                </Col>
              </Row>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn GreyBtn"
            onClick={() => setAssignDriverModel(false)}
          >
            Close
          </Button>
          <Button className="d-inline-flex align-items-center justify-content-center commonBtn ">
            Save changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AssignDriverPop;
